import {
    Layout,
    Button,
    Row,
    Col,
    Space,
    Typography,
} from 'antd';
import {
    ToggleIcon,
    // NotificationIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
} from '@/assets/images/icons';
import { firstToUpper } from '@/helpers/string';
import TopbarUserMenu from '../TopbarUserMenu';

const formatMenuName = (name) => {
    const splitName = name.split('-');
    if (splitName.length === 1) {
        return firstToUpper(name);
    }
    return splitName.map((item) => firstToUpper(item)).join(' ');
};

function Topbar({
    collapsed,
    setCollapsed,
    selectedKeys,
    setSelectedKeys,
}) {
    return (
        <Layout.Header className={`${!collapsed && 'sidebar-opened'}`}>
            <Row justify="space-between" className="topbar" align="top">
                <Col className="topbar-left-content">
                    <Button
                        type="text"
                        icon={collapsed ? <ToggleIcon /> : <ArrowLeftIcon />}
                        onClick={() => setCollapsed(!collapsed)}
                        className="toggle-button"
                    >
                        {selectedKeys.length > 1 ? (
                            <Space>
                                <Typography.Text>
                                    {`${formatMenuName(selectedKeys[1].toLowerCase())}`}
                                </Typography.Text>
                                <ArrowRightIcon />
                                <Typography.Text>
                                    {formatMenuName(selectedKeys[0].toLowerCase())}
                                </Typography.Text>
                            </Space>
                        ) : (
                            <Typography.Text>
                                {selectedKeys.length !== 0
                                    && formatMenuName(selectedKeys[0]?.toLowerCase())}
                            </Typography.Text>
                        )}
                    </Button>
                </Col>
                <Col className="topbar-right-content">
                    <div className="topbar-right-menu">
                        <Space size={20}>
                            {/* <NotificationIcon /> */}
                            <TopbarUserMenu setSelectedKeys={setSelectedKeys} />
                        </Space>
                    </div>
                </Col>
            </Row>
        </Layout.Header>
    );
}

export default Topbar;
